import type { GetCurrentUserQuery } from 'types/generated/client';

type CurrentUser = NonNullable<GetCurrentUserQuery['usersByPk']>;

/**
 * Coach onboarding status check — used to intercept nav-link clicks and pop
 * the activation modal when a coach hasn't finished the 3-step onboarding.
 */
export const getHasCoachOnboarded = (user: CurrentUser | null | undefined): boolean => {
  if (!user) return false;

  const step1Missing =
    !user.gender || !user.phoneNumber || !user.coachSports || user.coachSports.length === 0;
  if (step1Missing) return false;

  const step2Missing = !user.stripeMerchantChargesEnabled && !user.didSkipStripeSetup;
  if (step2Missing) return false;

  const step3Missing = !user.priceUnitAmountCoachDefault;
  if (step3Missing) return false;

  return true;
};
